import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

import Actions from '../../../../actions'
import { Spinner } from '../../../../components/generic'
import HomeEditForm from '../../../../components/forms/screens/HomeEditForm'
import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'

export class HomeProfileEdit extends Component {
  componentDidMount() {
    this.props.addForm(this.props.home)
  }

  componentDidUpdate(nextProps) {
    if (!this.props.home && nextProps.home) {
      this.props.addForm(nextProps.home)
    }
  }

  render() {
    const { home } = this.props
    if (!home) return <Spinner />
    return <HomeEditForm router={history} />
  }
}

HomeProfileEdit.propTypes = {
  addForm: PropTypes.func.isRequired,
  home: PropTypes.object,
}

const mapStateToProps = (state, props) => {
  const { id } = props.router.params
  return {
    home: _.find(state.data.homes, { id }),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addForm: (profile) =>
      dispatch(
        Actions.addForm({
          formId: 'editHome',
          initial: profile,
        })
      ),
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomeProfileEdit)
)
